export default __webpack_public_path__ + "static/media/P200-sm-open.0c96867d.svg";